<template>
  <div>
    <div class="flex">
      <div :class="classes">
        <div class="pbc-component-type-header p-0 pt-2">
          <div class="pbc-component-type-icon-parent">
            <component :is='icon' :size='16' class="pbc-component-type-icon" />
          </div>
          <div class="pbc-component-type-name">{{dbentry.text}}</div>
        </div>

        <p v-if='!$slots.default && disableRemove' class="text-gray-600 text-sm leading-loose tracking-wide font-light text-left align-middle p-2">
          {{dbentry.description}}
        </p>

      </div>

      <div v-if='$slots.default' class="grow overflow-hidden">
        <slot name='default' />
      </div>

      <div v-if='!isAllButtonsDisabled'>
        <div class="flex justify-end">
          <pbc-button v-if='!disableRemove' @click='remove'>
            <delete :size='40' />
          </pbc-button>
          <pbc-button v-if='!disableMoveto' @click='moveTo'>
            <chevron-right :size='40' />
          </pbc-button>
        </div>
      </div>
  </div>
    <!--
    <div class="flex mx-2 my-1 justify-center">
      <input class="self-center max-w-xs pbc-standard-input md:max-w-md" v-model='component.name' placeholder='Enter comment' />
    </div>
    -->
  </div>
</template>
<script>
import * as ComponentsDb from '@edit/tree/componentsdb.js';
import IconMapping from '@components/iconMapping.js';
import PlusCircle from '@icons/PlusCircle.vue';
import ChevronRight from '@icons/ChevronRight.vue';
import Delete from '@icons/Delete.vue';

export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    disableRemove: {
      type: Boolean,
      default: false
    },
    disableMoveto: {
      type: Boolean,
      default: false
    },
    disableAdd: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const {type} = this.component;
    const dbentry = ComponentsDb.findDbEntry(this.component);
    const icon = IconMapping[type];
    return {
      dbentry,
      icon
    }
  },
  methods: {
    add() {
      this.$emit('add', {component:this.component});
    },
    remove() {
      this.$emit('remove', {component:this.component});
    },
    moveTo() {
      console.log('poeskak');
      this.$emit('move-to', {component:this.component});
    }
  },
  components: {
    PlusCircle,
    ChevronRight,
    Delete
  },
  computed: {
    isAllButtonsDisabled() {
      return this.disableAdd && this.disableMoveto && this.disableRemove;
    },
    classes() {
      if (!this.isAllButtonsDisabled) {
        if (this.$slots.default) {
          return "max-w-icon-and-name overflow-hidden";
        } else {
          return "max-w-icon-and-name overflow-hidden flex-1";
        }
        //return "p-1 px-2 grow";
      } else if (this.disableRemove && this.disableMoveto && !this.disableAdd) {
        return "max-w-icon-and-name max-w-xs overflow-hidden flex-1";
      } else {
        return "max-w-icon-and-name flex-1 flex";
      }
    }
  }
  
}
</script>
<style>
.max-w-icon-and-name {
  width:5rem;
}
</style>
